import { useEffect } from 'react';
import { IHierarchyParameters } from './hierarchy-interfaces';
import { useHierarchyStore } from './dal/hierarchy-store';
import HierarchyParameters from './ui/parameters';
import HierarchyView from './ui/view';
import { getHierarchyJsonStorage } from './dal/hierarchy-storage';

const initialParameters: IHierarchyParameters = {
    "table": [
        [0, 4, 25, 24, 9, 7],
        [4, 0, 21, 20, 5, 3],
        [25, 21, 0, 1, 16, 18],
        [24, 20, 1, 0, 15, 17],
        [9, 5, 16, 15, 0, 2],
        [7, 3, 18, 17, 2, 0]
    ],
    "rowNames": ["A", "B", "C", "D", "E", "F"]
};

const HierarchyHome = () => {

    const params = useHierarchyStore(store => store.params);
    const setParams = useHierarchyStore(store => store.setParams);

    useEffect(() => {
        const dataFromStorage = getHierarchyJsonStorage();
        if(dataFromStorage) {
            try{
                const parsed = JSON.parse(dataFromStorage);
                setParams(parsed);
            }
            catch (_ex) {
                setParams(initialParameters);
            }
        }
        else{
            setParams(initialParameters);
        }
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">Hierarchy (ניתוח אשכולות)</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <HierarchyParameters />
                        <HierarchyView />
                    </div>
                }
            </div>

        </div>
    )
};

export default HierarchyHome;
